var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-complete"},[_c('div',{staticClass:"hero is-large"},[_c('div',{staticClass:"hero-body is-loading"})])])}]

export { render, staticRenderFns }